import { lazy } from 'solid-js'
import { messages } from '../../pages/booking-confirmation-page/booking-confirmation-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/booking-confirmation-page/booking-confirmation-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/booking-confirmation/:booking_id',
    showFooter: false,
    showHeaderMenu: false,
    showUserHeader: true,
    titleMessage: messages.titleMessage,
}
